import React from 'react';
import { File } from '@models/files';
import { Link } from 'react-router-dom';
import { fileDownloadUrl } from '@services/files';
import { useSelector } from 'react-redux';
import { IApplicationState } from '@store/reducer';
import { projectIdURLParam } from '@utils/urlUtils';

interface IFileInfo {
  currentFile: File;
  relativePath: string;
}

export const SingleFile: React.FC<IFileInfo> = ({
  currentFile,
  relativePath,
}) => {
  const { projectId } = useSelector((state: IApplicationState) => ({
    projectId: state.projectPicker.activeProjectId,
  }));
  const getUrl = () => {
    return (
      fileDownloadUrl(`${relativePath}/${encodeURI(currentFile.name)}`) +
      `?${projectIdURLParam(projectId)}`
    );
  };

  return (
    <div className='file-name'>
      <Link to={getUrl()} target={'_blank'}>
        <i className='fas fa-file'></i>
        {currentFile.name}
      </Link>
    </div>
  );
};
